<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21.53 18.5l-8.66-15a1 1 0 00-1.74 0l-8.66 15a1 1 0 000 1 1 1 0 00.87.5h17.32a1 1 0 00.87-.5 1 1 0 000-1zM5.07 18L12 6l6.93 12z"/><path d="M11 9.82V13a1 1 0 002 0V9.82a1 1 0 00-2 0zM11.12 15.12a1.22 1.22 0 00-.37.88 1.28 1.28 0 00.09.48 1.4 1.4 0 00.68.68 1.33 1.33 0 001 0 1.38 1.38 0 00.4-.28 1.2 1.2 0 00.37-.88 1.94 1.94 0 000-.24 1.13 1.13 0 00-.08-.24 1.39 1.39 0 00-.11-.21 1 1 0 00-.16-.19 1.27 1.27 0 00-1.82 0z"/></svg>